import { Link, PrimaryButton, ProgressIndicator, TextField } from "@fluentui/react";
import { primaryButtonStyles, styles, textFieldStyles } from "../../common/views/DefaultStyles";
import { Utils } from "../../common/views/Utils";
import { KeyValue } from "../../home/models/OtherTypes";
import { AccountConfirmModel, AccountProvider } from "../models/AccountTypes";
import { ResetPasswordView } from "./ResetPasswordView";

type ConfirmAccountProps = {
    form: AccountConfirmModel;
    errorMessages: any;
    loading: boolean;
    counter: number;
    lastByEmail: boolean;
    onValueChange: (field: keyof AccountConfirmModel, value: any) => void;
    resendCode: (isByEmail: boolean) => void;
    confirm: (isByEmail: boolean) => void;
    showResetPassword: boolean;
}

export function ConfirmAccountView({
    form, errorMessages, onValueChange, lastByEmail, resendCode, confirm, loading, showResetPassword
}: ConfirmAccountProps) {
    const isMobile = Utils.isMobile();
    const id = "login-form-wrapper" + (isMobile ? "-mobile" : "");

    const codeInput = () => {
        return <div className="pt-10">
            <TextField
                label=""
                defaultValue={form.code}
                errorMessage={errorMessages.firstName}
                onChange={(_, v) => onValueChange("code", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const resendButton = () => {
        return <div className="pt-10">
            <span
                onClick={() => resendCode(lastByEmail)}
                className="cursor"
                style={{ textDecoration: "underline" }}
            >Resend Code?</span>
        </div>
    }

    const onConfirm = () => {
        confirm(lastByEmail);
    }

    const submitButton = () => {
        return <div className="pt-20">
            <PrimaryButton onClick={onConfirm} styles={primaryButtonStyles}>
                Confirm
            </PrimaryButton>
        </div>;
    }

    const resendOptions = () => {
        return <div className="pt-20">
            <div className="font-bolder">Confirm Options</div>

            <ul>
                {form.options.map((option: KeyValue<string, AccountProvider>) => {
                    return <li className="pt-10">
                        <Link onClick={() => resendCode(option.value === AccountProvider.email)}>
                            Send to {AccountProvider[option.value]}: {option.key}
                        </Link>
                    </li>;
                })}
            </ul>
        </div>;
    }

    const mainContent = () => {
        return <div id={id} className="pv-10 ph-15" style={styles.middle}>
            <div className="login-form box">
                <div className="ms-Grid left ph-0">
                    <div className={"left font-title p-15"} style={{ paddingTop: 6 }}>
                        Account Confirmation
                    </div>

                    <hr style={{ backgroundColor: "lightgray", height: 1, border: "none" }} />

                    <div className="pt-10 pb-20 ph-15">
                        <div>Code has been sent to your SMS / Email. Enter code.</div>
                        {codeInput()}
                        {resendButton()}

                        {!loading && submitButton()}
                        {loading && <div className="pt-10">
                            <ProgressIndicator label="Submitting" description="" />
                        </div>}

                        {resendOptions()}
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        {showResetPassword && <ResetPasswordView info={form} />}
        {!showResetPassword && mainContent()}
    </>
}